import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Hero from '@/pages/traffic-master/components/Hero';
import Services from '@/pages/traffic-master/components/Services';
import Ecosystem from '@/pages/traffic-master/components/Ecosystem';
import MonthlyDeliverables from '@/pages/traffic-master/components/MonthlyDeliverables';
import Process from '@/pages/traffic-master/components/Process';
import Results from '@/pages/traffic-master/components/Results';
import IdealFor from '@/pages/traffic-master/components/IdealFor';
import Comparison from '@/pages/traffic-master/components/Comparison';
import Pricing from '@/pages/traffic-master/components/Pricing';
import FAQ from '@/pages/traffic-master/components/FAQ';
import FinalCTA from '@/pages/traffic-master/components/FinalCTA';

export default function TrafficMaster() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Ecosystem />
        <MonthlyDeliverables />
        <Process />
        <Results />
        <IdealFor />
        <Comparison />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}